import { Avatar, IconButton, Tooltip, Typography } from '@mui/material';
import Grid from '@mui/material/Grid2';
import { useEffect } from 'react';
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import ContentLoader from '../subcomponents/ContentLoader';
import PageLayout from '../subcomponents/PageLayout';
import FavoriteCard from './FavoriteCard';
import FavoritesCheckMessage from './FavoritesCheckMessage';
import { fetchFavorites } from './favoritesSlice';

import AddIcon from '@mui/icons-material/Add';

export default function FavoritesPage() {
    const dispatch = useDispatch();
    const navigate = useNavigate();

    const { student } = useSelector((state) => state.student);
    const { appLanguage, resourceFinal } = useSelector((state) => state.settings.resource.resources);
    const { favorites, favoriteRemove } = useSelector((state) => state.favorites);
    const { activeDepartment, departmentThemesStatus } = useSelector((state) => state.settings.theme);
    const { siomSettings } = useSelector((state) => state.settings.siom);

    useEffect(() => {
        if (student !== null) {
            if (siomSettings.useMultipleDepartments) {
                if (activeDepartment !== null) {
                    dispatch(fetchFavorites(activeDepartment[0].id));
                };
            } else {
                dispatch(fetchFavorites(null));
            };
        };
    }, [dispatch, siomSettings, student, favoriteRemove.status, activeDepartment, departmentThemesStatus]);

    const AddClick = () => {
        navigate(`/favorieten-toevoegen`);
    };

    return (
        <PageLayout
            title={resourceFinal[appLanguage].words.FAVORITES}
            content={
                <ContentLoader
                    successCondition={favorites.status === "success"}
                    errorCondition={favorites.status === "failed"}
                    content={
                        <>
                            <FavoritesCheckMessage />
                            <Grid container spacing={{ xs: 1, md: 2 }} sx={{ display: 'flex', justifyContent: 'center' }}>
                                {favorites.status === "success" ? favorites.data?.map((item) =>
                                    <Grid key={item.id}>
                                        <FavoriteCard favoritePage={true} itemId={item.id} activityId={item.activityId} name={item.name} imageUrl={item.imageUrl} />
                                    </Grid>
                                ) : ""}
                                {favorites.status === "success" ? Object.keys(favorites.data).length === 0 ? (
                                    <Grid size={{ xs: 12 }} sx={{ display: 'flex', justifyContent: 'center' }}>
                                        <Typography variant="h6" sx={{ my: 'auto', textAlign: 'center' }}>{resourceFinal[appLanguage].messages.NO_FAVORITES}</Typography>
                                    </Grid>
                                ) : "" : ""}
                            </Grid>

                        </>
                    }
                />
            } contentBottom={
                <IconButton onClick={AddClick}>
                    <AddIcon sx={{ color: 'white.main', fontSize: 32 }} />
                </IconButton>
            } contentRight={
                <Tooltip title={resourceFinal[appLanguage].words.ADD} placement="left" arrow>
                    <IconButton onClick={AddClick}>
                        <Avatar sx={{ bgcolor: 'secondary.main', p: 0.5 }}>
                            <AddIcon sx={{ color: 'white.main', fontSize: 40 }} />
                        </Avatar>
                    </IconButton>
                </Tooltip>
            }
            bottomBar
            disableHeaderBackground
            disableContentBackground
        />
    );
}
